<template>
  <div class="all_part">
    <div class="logo">
      <img src="../assets/main_menu_Phone/Logo.png" alt=""/>
    </div>
    <div style="margin:20px 0;color: brown">
      <span>所属象限：</span>
      <span>{{ tableData2.quadrant }}</span>
    </div>
    <div class="info_span_chack" v-if="PanDuanXiuGai==1">
      <div class="all_span">
        <div class="part_span" v-if="tableData2.quadrant_id==1">
          <div class="info_span">
            <span>竞争对手：</span>
            <span>{{ tableData2.enterprise }}</span>
          </div>
          <div class="info_span">
            <span>竞争人员：</span>
            <span>{{ tableData2.enterprise_name }}</span>
          </div>
          <div class="info_span">
            <span>竞争对手关联类型：</span>
            <span>{{ tableData2.enterprise_type }}</span>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==3||tableData2.quadrant_id ==1">
          <div class="info_span">
            <span>FAB用户：</span>
            <span>{{ tableData2.enterprise_end }}</span>
          </div>
          <div class="info_span">
            <span>FAB关联人员:</span>
            <span>{{ tableData2.enterprise_end_name }}</span>
          </div>
          <div class="info_span">
            <span>FAB关联类型:</span>
            <span>{{ tableData2.enterprise_end_type }}</span>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5||tableData2.quadrant_id ==3">
          <div class="info_span">
            <span>OEM厂商:</span>
            <span>{{ tableData2.equipment_supplier }}</span>
          </div>
          <div class="info_span">
            <span>OEM用户:</span>
            <span>{{ tableData2.related_personnel_supplier_name }}</span>
          </div>
          <div class="info_span">
            <span>OEM关联类型:</span>
            <span>{{ tableData2.equipment_supplier_type }}</span>
          </div>
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5">
          <div class="info_span">
            <span>竞争对手：</span>
            <span>{{ tableData2.enterprise }}</span>
          </div>
          <div class="info_span">
            <span>竞争人员：</span>
            <span>{{ tableData2.enterprise_name }}</span>
          </div>
          <div class="info_span">
            <span>竞争对手关联类型：</span>
            <span>{{ tableData2.enterprise_type }}</span>
          </div>
        </div>
      </div>
      <div class="all_span">
        <div class="info_span" v-if="tableData2.quadrant_id!=1">
          <span>设备型号：</span>
          <span>{{ tableData2.device_type }}</span>
        </div>
        <div class="info_span">
          <span>制程工艺：</span>
          <span>{{ tableData2.process_technology }}</span>
        </div>
        <div class="info_span" v-if="tableData2.quadrant_id!=5">
          <span>竞品类别：</span>
          <span>{{ tableData2.category }}</span>
        </div>
        <div class="info_span">
          <span>竞品设备情况：</span>
        </div>
        <div class="info_span">
          <span style="    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    color: brown;">{{ tableData2.equipment_condition }}</span>
        </div>
        <div class="info_span">
          <span>人员关系:</span>
          <span>{{ tableData2.personnel_relations }}</span>
        </div>
        <div class="info_span">
          <span>提交人员:</span>
          <span>{{ tableData2.name }}</span>
        </div>
        <div class="info_span">
          <span>联系方式:</span>
          <span>{{ tableData2.phone }}</span>
        </div>
      </div>
    </div>
    <div class="Update_input" v-if="PanDuanXiuGai==0">
      <div class="all_span">
        <div class="part_span" v-if="tableData2.quadrant_id==1">
          <div class="Update_input_title">
            <span>竞争对手：</span>
            <el-select v-model="companyChoice" filterable :placeholder="tableData2.enterprise" style="width: 190px"
                       value-key="id"
                       clearable @change="change('a', companyChoice)">
              <el-option
                  v-for="item in companyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>竞争人员：</span>
            <el-select v-model="staff_name_select" filterable style="width: 190px">
              <el-option
                  v-for="item in companyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>

          </div>
          <!--          <div class="Update_input_title">-->
          <!--            <span>关联类型</span>-->
          <!--            <div>-->
          <!--              <el-radio-group v-model="selectC">-->
          <!--                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
          <!--                          style="    margin-right: 7px;"-->
          <!--                          :disabled="opt.id!=pan_input">-->
          <!--                  {{ opt.value }}-->
          <!--                </el-radio>-->
          <!--              </el-radio-group>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==3||tableData2.quadrant_id ==1">
          <div class="Update_input_title">
            <span>FAB用户：</span>
            <el-select v-model="FABcompanChoice" filterable placeholder="请选择" style="width: 190px"
                       value-key="id"
                       clearable @change="change('b', FABcompanChoice)">
              <el-option
                  v-for="item in FABcompanyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>FAB关联人员:</span>
            <el-select v-model="FABstaff_name_select" filterable placeholder="请选择" style="width: 190px">
              <el-option
                  v-for="item in FABcompanyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--          <div class="Update_input_title">-->
          <!--            <span>FAB关联类型:</span>-->
          <!--            <el-radio-group v-model="selectFAB">-->
          <!--              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)" style="margin-right: 7px"-->
          <!--                        :disabled="opt.id!=pan_input">-->
          <!--                {{ opt.value }}-->
          <!--              </el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </div>-->
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5||tableData2.quadrant_id ==3">
          <div class="Update_input_title">
            <span>OEM厂商:</span>
            <el-select v-model="OEMcompanyChoice" filterable placeholder="请选择" style="width: 190px"
                       value-key="id"
                       clearable @change="change('c', OEMcompanyChoice)">
              <el-option
                  v-for="item in OEMcompanyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>OEM用户:</span>
            <el-select v-model="OEMstaff_name_select" filterable placeholder="请选择" style="width: 190px">
              <el-option
                  v-for="item in OEMcompanyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--          <div class="Update_input_title">-->
          <!--            <span>OEM关联类型:</span>-->
          <!--            <el-radio-group v-model="selectOEMs">-->
          <!--              <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)" style="margin-right: 7px"-->
          <!--                        :disabled="opt.id!=pan_input">-->
          <!--                {{ opt.value }}-->
          <!--              </el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </div>-->
        </div>
        <div class="part_span" v-if="tableData2.quadrant_id==5">
          <div class="Update_input_title">
            <span>竞争对手：</span>
            <el-select v-model="companyChoice" filterable :placeholder="tableData2.enterprise" style="width: 190px"
                       value-key="id"
                       clearable @change="change('a', companyChoice)">
              <el-option
                  v-for="item in companyTable"
                  :key="item.id"
                  :label="item.enterprise"
                  :value="{id:item.id, companyName:item.enterprise}"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Update_input_title">
            <span>竞争人员：</span>
            <el-select v-model="staff_name_select" filterable style="width: 190px">
              <el-option

                  v-for="item in companyStaffTable"
                  :key="item.value"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>

          </div>
          <!--          <div class="Update_input_title">-->
          <!--            <span>关联类型</span>-->
          <!--            <div>-->
          <!--              <el-radio-group v-model="selectC">-->
          <!--                <el-radio v-for="opt in selectTable" :key="opt.id" :label="String(opt.value)"-->
          <!--                          style="    margin-right: 7px;"-->
          <!--                          :disabled="opt.id!=pan_input">-->
          <!--                  {{ opt.value }}-->
          <!--                </el-radio>-->
          <!--              </el-radio-group>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="all_span">
        <div class="Update_input_title" v-if="tableData2.quadrant_id!=1">
          <span>设备型号：</span>
          <el-select v-model="deviceChoice" filterable placeholder="请选择" style="width: 190px" clearable
                     @change="change('d', companyChoice)">
            <el-option
                v-for="item in deviceTable"
                :key="item.value"
                :label="item.device_type"
                :value="item.device_type">
            </el-option>
          </el-select>
        </div>
        <div class="Update_input_title">
          <span>制程工艺：</span>
          <el-select v-model="processChoice" filterable placeholder="请选择" style="width: 190px">
            <el-option
                v-for="item in processTable"
                :key="item.value"
                :label="item.process_technology"
                :value="item.process_technology">
            </el-option>
          </el-select>
        </div>
        <div class="Update_input_title" v-if="tableData2.quadrant_id!=5">
          <span>竞品类别：</span>
          <el-select v-model="categoryChoice" filterable placeholder="请选择" style="width: 190px">
            <el-option
                v-for="item in categoryTable"
                :key="item.value"
                :label="item.title"
                :value="item.title">
            </el-option>
          </el-select>
        </div>
        <div class="Update_input_title">
          <span>竞品设备情况：</span>
          <el-input type="textarea" style="width: 190px" v-model="JingPingDevice"></el-input>
        </div>
        <div class="Update_input_title">
          <span>人员关系:</span>
          <el-input style="width: 190px" v-model="RenYuanGuanXI"></el-input>
        </div>
        <div class="Update_input_title">
          <span>提交人员:</span>
          <el-input style="width: 190px" v-model="TijiaoUser"></el-input>
        </div>
        <div class="Update_input_title">
          <span>联系方式:</span>
          <el-input style="width: 190px" v-model="phone"></el-input>
        </div>

      </div>
    </div>
    <div   v-if="PanDuanXiuGai==0" style="margin-bottom:10px">
      <el-button @click="updateAll()">修改</el-button>
      <el-button @click="Pan_update()">返回</el-button>
      <el-button @click="Back_update()">返回竞品登记</el-button>
    </div>
    <div v-if="PanDuanXiuGai==1" style="margin-bottom:10px">
      <el-button @click="Pan_update()">修改</el-button>
      <el-button @click="Back_update()">返回竞品登记</el-button>
    </div>
    <div></div>
  </div>
</template>

<script>
import {httpUrl} from "../components/publics";
import {createApp} from 'vue';

export default {
  name: "Main_menuPhone_JiaGeYuKuCun",
  data() {
    return {
      JingPingDevice: "",
      RenYuanGuanXI: "",
      TijiaoUser: "",
      phone: "",
      PanDuanXiuGai: 1,
      info_id: "",
      pan_Show: false,
      pan_input: "",
      pan_input2: "",
      jinxuan2: 1,
      jinxuan3: 3,
      jinxuan4: 5,
      selectFAB: "",
      add_companyTable: 0,
      add_staff_type: 0,
      add_company_name: "",
      add_company_abbreviation: "",
      companyStaffTable: {},
      companyStaffChoice: "",
      jinxuan: "",//判断是否禁选和传过来的UserID进行比较
      selectC: "",//单选框值
      companyTable: {},//公司列表
      FABcompanyTable: {},//FAB公司列表
      companyChoice: {},//公司列表
      OEMcompanyTable: {},//OEM公司列表
      OEMcompanyChoice: {},//公司列表
      FABcompanChoice: {},//FAB公司选择
      selectTable: {},//单选框列表
      deviceTable: {},//设备列表
      deviceChoice: "",//设备选择
      processTable: {},//制程工艺列表
      processChoice: "",//制程工艺列表
      categoryTable: {},//制程工艺列表
      categoryChoice: "",//制程工艺列表
      staff_Name: "",
      staff_phone: "",
      staff_wechart: "",
      staff_companyChoice: "",
      staff_name_select: "",
      FABstaff_name_select: "",
      OEMstaff_name_select: "",
      FABcompanyStaffTable: {},//FAB员工列表
      OEMcompanyStaffTable: {},//OEM员工列表
      add_device_type: 0,
      add_process: 0,
      add_category: 0,
      add_device: "",
      add_process_input: "",
      add_category_input: "",
      selectOEM: "",
      selectOEMs: "",
      urlImage: '',
      fileList: [],
      tableTable: [],
      user_leave: {},
      tableData: [],
      tableData2: [],
      key: "",
    };
  },
  mounted() {
    console.log(this.$route.params.data, '这里看的是params')
    if (this.$route.params.data != '') {
      this.infoAll(this.$route.params.data)
    }
    this.selectcompany();
    this.selectFABcompany();
    this.selectOEMcompany();
    this.getUser();
    this.selectName();


    this.getUser();

  },
  watch: {
    companyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectcompanystaff(newName.id);
    },
    FABcompanChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectFABcompanystaff(newName.id);
    },
    OEMcompanyChoice(newName, oldName) {
      // console.log(newName.id,'这里看的是参数')
      this.selectOEMcompanystaff(newName.id);
    },

  },
  methods: {
    Pan_update() {
      this.PanDuanXiuGai = !this.PanDuanXiuGai
    },
    Back_update() {
      this.$router.push("/CompetitionRegistration_phone");
    },
    change(params, val) {
      console.log(params, '这里测试的是parames');
      if (params == "a" && val != "") {
        this.staff_name_select = "";
      }
      if (params == "b" && val != "") {
        this.FABstaff_name_select = "";
      }
      if (params == "c" && val != "") {
        this.OEMstaff_name_select = "";
      }
    },
    updateAll() {
      console.log(this.companyChoice)
      this.axios
          .post(
              httpUrl + "/api/competitive_product/competitiveProductEdit",
              this.$qs.stringify({
                id: this.tableData2.id,
                quadrant_id: this.tableData2.quadrant_id,
                enterprise_id: this.companyChoice.id,
                enterprise_user_id: this.staff_name_select,
                enterprise_type: this.selectC,
                enterprise_end_id: this.FABcompanChoice.id,
                enterprise_end_user_id: this.FABcompanyStaffTable,
                enterprise_end_type: this.selectFAB,
                equipment_supplier_id: this.OEMcompanyChoice.id,
                equipment_supplier_user_id: this.OEMstaff_name_select,
                equipment_supplier_type: this.selectOEMs,
                device_type: this.deviceChoice,
                process_technology: this.processChoice,
                category: this.categoryChoice,
                equipment_condition: this.JingPingDevice,
                personnel_relations: this.RenYuanGuanXI,
              })
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.$message(response.data.message);
              console.log("success", response.data);
              this.add_staff_type = 0;
              this.selectFABcompany()
            } else {
              console.log(response.data.code);
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));

    },
    infoAll(infoID) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/competitiveProductDetails?id=${infoID}`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.tableData2 = response.data.data;
              this.companyChoice.id = response.data.data.enterprise_id
              this.companyChoice.companyName = response.data.data.enterprise
              this.selectcompanystaff(response.data.data.enterprise_id)
              this.staff_name_select = response.data.data.enterprise_user_id
              this.selectName()
              this.selectC = response.data.data.enterprise_type
              this.FABcompanChoice.id = response.data.data.enterprise_end_id
              this.FABcompanChoice.companyName = response.data.data.enterprise_end_name
              this.selectFABcompanystaff(response.data.data.enterprise_end_id);
              this.FABstaff_name_select = response.data.data.enterprise_end_user_id
              this.selectFAB = response.data.data.enterprise_end_type
              this.OEMcompanyChoice.id = response.data.data.equipment_supplier_id
              this.OEMcompanyChoice.companyName = response.data.data.equipment_supplier
              this.selectOEMcompanystaff(response.data.data.equipment_supplier_id);
              this.OEMstaff_name_select = response.data.data.equipment_supplier_user_id
              this.selectTable = response.data.data.equipment_supplier_type
              this.selectdevice();
              this.deviceChoice = response.data.data.device_type;
              this.selectprocess();
              this.processChoice = response.data.data.process_technology;
              this.selectCategory();
              this.categoryChoice = response.data.data.category;
              this.JingPingDevice = response.data.data.equipment_condition;
              this.RenYuanGuanXI = response.data.data.personnel_relations;
              this.TijiaoUser = response.data.data.name;
              this.phone = response.data.data.phone;
              console.log(this.tableData2)
              if (response.data.code == 401) {
                this.$message(response.data.message);
              } else {
                // response.data.data.map((value, key) => {
                //   if (value.child.length > 0) {
                //     value.child.map((val, num) => {
                //       val["id"] = value.id * 10 + num;
                //     });
                //   }
                // });
                this.tableData2 = response.data.data;
              }
              // this.tableData = response.data.data
              // console.log(this.tableData.data)
              //     newItemNo:"",//新料号
              //     oldMaterialNo:"",//旧料号
              //     internal_meridian:"", // 产品内径
              //     wire_diameter:"",//产品线径
              //     ChanPinXiaoLei_choice:"",//产品小类选择
              //     CaiZhi_choice:"",//材质选择   //material
              //     BiaoZhun_Choice:"",//标准选择
              //     YingDu_Choice:"",//硬度选择
              //     standard_code:"",//标准代码
              //     inquiry_no:"",//询价单号
              //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
              //     ChanPinDaLei_choice:"", // 产品大类选择
              //     YanSe_Choice:"",//颜色选择
              //     ChanPinDaLei_Select:[],  // 产品大类下拉框
              //     ChanPinXiaoLei_Select:[],//产品小类下拉框
              //     CaiZhi_select:[], //材质选择拉下
              //     BiaoZhun_Select:[],//标准下拉框
              //     YingDu_Select:[],//硬度下拉框
              //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
              //     YanSe_Select:[],//颜色下拉框
            }
            // this.$message("搜索成功");
            this.$message(response.data.message);
          })
          .catch((error) => console.log(error, "error"));
    },
    selectcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel?enterprise_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyStaffTable = response.data.data;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectFABcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_end?enterprise_end_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    selectOEMcompanystaff(newNames) {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/related_personnel_supplier?enterprise_supplier_id=${newNames} `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyStaffTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询公司列表
    selectcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.companyTable = response.data.data;
              console.log(companyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询FAB列表
    selectFABcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/enterprise_end`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.FABcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询OEM列表
    selectOEMcompany() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/equipment_supplier`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.OEMcompanyTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询设备列表
    selectdevice() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/device_type`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.deviceTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //查询制程工艺列表
    selectprocess() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/process_technology`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.processTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //竞品类别列表
    selectCategory() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/category`
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.categoryTable = response.data.data;
              // console.log(FABcompanyTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    //单选框赋值
    selectName() {
      this.axios
          .get(
              httpUrl +
              `/api/competitive_product/association `
          )
          .then((response) => {
            if (response.data.code == 200) {
              this.selectTable = response.data.data;
              // console.log(selectTable)
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },

  },
};
</script>

<style>
</style>
<style scoped>
.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 40%;
  height: 70%;
}

.CompetitiveChoice_button_alone {

  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 270pt;
  height: 102pt;

  border-radius: 4px;
}

.all_part {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("../assets/Login_img_phone/bg1.png");
}

.main_button {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 85%;
}

.logo {
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 142pt;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo img {
  margin-top: 18px;
}

.JiaGeKuCun {
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
}

.button {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120pt;
  width: 120pt;
  background-color: #409eff;
  border-radius: 6px;
}

.buttons {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 130pt;
  width: 130pt;
  background-color: none;
  border-radius: 6px;
}

.button img {
  width: 40pt;
  height: 44.5pt;
  display: flex;
}

.button span {
  font-weight: 500;
  color: #ffffff;
  font-size: 14pt;
  margin-top: 12px;
}

.TwoButton {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.search_button {
  margin-bottom: 20px;
}

.alone_span_title {
  color: #ffffff;
  font-size: 18px;
}

.alone_span_user {
  color: #ffffff;
  font-size: 20px;
}

.Competitive_span {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.CompetitiveChoice {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: 100%;
}

.CompetitiveChoice_button_alone {
  background: #8EC31F;
  height: 80%;
  width: 90%;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
}

.CompetitiveChoice_button {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss div {
  /*background: #FC6700*/
  background: #999999;
}

.CompetitiveChoice_buttonss1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss1 div {
  background: #fe9001;
}

.CompetitiveChoice_buttonss2 {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss2 div {
  background: #40C121;
}

.CompetitiveChoice_buttonss3 {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 120pt;
  height: 60pt;
  border-radius: 4px;
}

.CompetitiveChoice_buttonss3 div {
  background: #2268D0;
}

.Main_menu_button_cl {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Main_menu_button_cls {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.el-radio-group >>> .el-radio is-checked >>> .el-radio {
  margin-right: 15px;
}

.add_staff_info_titleAndInput {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  text-align: right;

}

.add_staff_info_titleAndInput span {
  width: 22%;
  text-align: right;
}

.add_info {
  width: 85%;
  height: 35%;
  background: #42b983;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 6px;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}

.input_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.all_part {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  /* justify-content: space-between; */
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  justify-content: center;
  height: 32%;

}

.all_input_top {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.Ctrl_padding {
  height: 40%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_all {
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 10px;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {
  display: flex;
  flex-direction: row;
}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 48%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 0 10px;
}

.titles {

  margin-top: 10px;
  display: flex;
  margin-bottom: 10px;

}

.ss {
  height: 55px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.list_div_div {
  width: 30%;
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}

.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.all_input_bottom {
  flex-direction: column;
  height: 20%;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}

.input_left div {
  margin-bottom: 20px;
}

.all_control {
  margin-bottom: 20px;
  padding: 0 5px;
}

.all_control_input_button {
  display: flex;
  flex-direction: column;
}

.type_selection {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.Type_title {
  font-weight: 600;
  text-align: left;
  margin-bottom: 20px;
}

.title_input_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.title_input_buttons {
  margin-bottom: 20px;
}

.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
}


.heads_menus {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu {
  padding: 0;
  margin: 0;
  width: 74%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: rgb(235, 235, 235) 1px solid;
  align-items: center;
}

.heads_menu_icon img {
  width: 24px;
}


.all_part {
  min-height: 100vh;
  background-color: #f2f2f2;
}

.head {
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  height: 45px;
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  position: fixed;
  z-index: 99;
}

.heads {
  padding-top: 40px;
  flex-direction: column;
  width: 42%;
  justify-content: space-around;
  display: flex;
  align-items: center;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  z-index: 98;
  border-radius: 4px;
  box-shadow: 2px 1px 6px 6px #ccc;
}

.heads span {
  color: #000;
  font-size: 13px;
  line-height: 20px;
  font-weight: 250;
}

.heads_button {
  width: 70%;
  height: 40px;
  display: flex;

  align-items: center;
  justify-content: center;
}

.head span {
  color: #ffffff;
  font-size: 20px;
  line-height: 20px;
  font-weight: 550;
}

.back img {
  margin-top: 5px;
}

.titleName {
  display: flex;
  justify-content: center;
}

.back {
  margin: 0 5px;
}


.all_input_top {
  /*height: 50%;*/
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0;
}

.all_input_bottom {
  height: 50%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.all_input_top_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_top_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_input_bottom_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.all_button {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
  margin-top: 15px;
}

.input {
  margin-bottom: 10px;
}

.all_key {

  display: flex;
  flex-direction: column;
}

.two_spans {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: aqua;
}

.Key {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 8pt;
  margin-bottom: 4px;
  justify-content: space-between;
}

.serch {
  width: 60%;
}

.list_div {
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  background-image: url("../assets/table_logo2.png");
  border-radius: 5px;
  padding: 10px 7px;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
}

.titleAndicon {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title_icon {
  margin-right: 20px;
}

.sousuoButton {
  position: relative;
}

.sousuo_icon {
  top: 16px;
  left: 16px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 10px;
  position: absolute;
}

.ShouQi {
  margin-bottom: 10px;
}

.ShouQis {
  height: 74px;
  align-items: center;
  display: flex;
  flex-direction: column;

  transform: rotate(180deg);
}

.icon_Shou {
  top: 14px;
  left: 12px;
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;
  transform: rotate(180deg);
}

.all_spans1 {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.all_spans {
  padding: 0 10px;
}

.titles {
  width: 100%;
  margin-top: 10px;
  display: flex;
}

.ss {
  height: 45px;
}

.XinJiuBianHao {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.second_span {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.double_span {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.double_spans {
  width: 48%;
}

.list_div_divs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.list_div_div {
  width: 100%;
  display: flex;
  flex-direction: column;

}

.list_div {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 6px 14px;
  /* background-image: url(./../assets/img_cx_sylogo@2x.png); */
  background-size: 190px 102px;
}

.list_div_p_span {
  color: #008de3;
}

.list_div_span {
  color: #222222;
  width: 300px
}

.list_div_p {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: left;
  margin: 6.5px 0;
}

.list_div_button {
  font-size: 12px;
  line-height: 12px;
  color: #a2a2a2;
  text-align: right;
  margin: 6.5px 0;
}

.CompetitiveChoices {
  display: flex;
  flex-direction: row;
}

.change_tab {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 30px;
}

.bottom_ch {
  border-bottom: #008de3 1px solid;
}

.Update_input_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;

}

.Update_input {
  padding: 0 20px
}

.info_span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 14px;
}

.info_span_chack {
  padding: 0 10px;
}
</style>